
import {defineComponent} from "vue";
import ProductSelectionTrademarksSelection
  from "@/components/layouts/catalog/product-selection/ProductSelectionTrademarksSelection.vue";
import {mapActions} from "vuex";
import ProductSelectionTrademarksFilters
  from "@/components/layouts/catalog/product-selection/ProductSelectionTrademarksFilters.vue";
import AlertError from "@/components/UI/Bootstrap/Alert/AlertError.vue";
import {Exception} from "@/api/interfaces";
import {SelectionTypeEnum} from "@/api/enums/selection-type-enum";

export default defineComponent({
  name: "ProductSelectionTrademarks",
  components: {AlertError, ProductSelectionTrademarksFilters, ProductSelectionTrademarksSelection},
  emits: ["savedSuccessfully"],
  data: () => ({
    exceptions: [] as Exception[],

    isReadyBase: false as Boolean,
    isReadyInclude: false as Boolean,
    isReadyExclude: false as Boolean,
  }),
  mounted() {
    this.reloadContent(false);
  },
  methods: {
    ...mapActions('cpc_mgmt', [
      'resetCurrentPage',
      'searchProductSelectionTrademarks',
      'saveProductSelectionTrademark'
    ]),
    resetAllCurrentPages() {
      this.resetCurrentPage({
        filter_selection_type_code: SelectionTypeEnum.BASE_SELECTION,
        type: 'TRADEMARK'
      });
      this.resetCurrentPage({
        filter_selection_type_code: SelectionTypeEnum.INCLUDE,
        type: 'TRADEMARK'
      });
      this.resetCurrentPage({
        filter_selection_type_code: SelectionTypeEnum.EXCLUDE,
        type: 'TRADEMARK'
      });
    },
    setIsReady(filter_selection_type_code: string, value: boolean) {
      switch (filter_selection_type_code) {
        case SelectionTypeEnum.BASE_SELECTION:
          this.isReadyBase = value;
          break;
        case SelectionTypeEnum.INCLUDE:
          this.isReadyInclude = value;
          break;
        case SelectionTypeEnum.EXCLUDE:
          this.isReadyExclude = value;
          break;
        default:
          throw new Error('Unsupported isReady to search ' + filter_selection_type_code);
      }
    },
    async submitSearch() {
      //When initiating a search, set all pages back to 1
      this.resetAllCurrentPages();
      await this.reloadContent(true);
    },
    async reloadContent(isBaseSelectionNeeded : boolean) {
      try {
        const promises = [
          this.searchTrademarks(SelectionTypeEnum.INCLUDE),
          this.searchTrademarks(SelectionTypeEnum.EXCLUDE),
        ];
        if (isBaseSelectionNeeded) {
          promises.unshift(this.searchTrademarks(SelectionTypeEnum.BASE_SELECTION));
        } else {
          this.setIsReady(SelectionTypeEnum.BASE_SELECTION, true);
        }
        await Promise.all(promises);
      } catch (exceptions: any) {
        this.exceptions = exceptions;
      }
    },
    async searchTrademarks(filter_selection_type_code: string) {
      this.setIsReady(filter_selection_type_code, false);

      try {
        await this.searchProductSelectionTrademarks({
          filter_selection_type_code: filter_selection_type_code,
        });
      } catch (exceptions: any) {
        this.exceptions = exceptions;
      }

      this.setIsReady(filter_selection_type_code, true);
    },
    async updateTrademarkItem(trademark_code: string, selection_type_code: SelectionTypeEnum) {
      this.exceptions = [];

      try {
        // console.log(`Update trademark with code: ${trademark_code} (${selection_type_code})`);
        await this.saveProductSelectionTrademark({
          trademark_code: trademark_code,
          selection_type_code: selection_type_code,
        });
      } catch (exceptions: any) {
        this.exceptions = exceptions;
      }

      await this.reloadContent(true);
    },
  }
});
